/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: LinkBuiltinPanel.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/4 @ 1722
 * ---
 * Description:
 */

import { observer }                 from 'mobx-react';
import { Editor }                   from '../../../../store/observables/Editor';
import { ItemRenderer, Select }     from '@blueprintjs/select';
import { Builtins }                 from '@revodigital/mle-dataresolver';
import { Button, MenuItem, Tag }    from '@blueprintjs/core';
import { useState }                 from 'react';
import { BuiltinDataRef, IDataRef } from '@revodigital/mpes';

interface Props {
  editor: Editor;
  onDataOriginChange: (dataRef: IDataRef | undefined) => void;
}

interface BuiltinValue {
  readableName: string;
  codeName: string;
  type?: string;
}

const BuiltinSelect = Select.ofType<BuiltinValue>();

/**
 * Elenco di valori builtin
 */
const builtinValues: BuiltinValue[] = [{
  readableName: 'Data di creazione',
  codeName: Builtins.CREATION_DATE,
  type: 'Data',
}, {
  readableName: 'Ultima modifica',
  codeName: Builtins.LAST_EDIT_DATE,
  type: 'Data'
}, {
  readableName: 'Nome azienda',
  codeName: Builtins.COMPANY_NAME,
  type: 'Testo'
}, {
  readableName: 'Nome utente',
  codeName: Builtins.USER_NAME,
  type: 'Testo'
}, {
  readableName: 'Titolo etichetta',
  codeName: Builtins.LABEL_TITLE
}];

export const LinkBuiltinPanel = observer((props: Props) => {
  const [selectedBuiltin, setSelectedBuiltin] = useState<BuiltinValue>();

  const itemRenderer: ItemRenderer<BuiltinValue> = (item, {
    handleClick,
    index
  }) => {
    return (
      <MenuItem text={ item.readableName } key={ item.codeName }
                onClick={ handleClick }
                labelElement={ item.type ?
                               <Tag>{ item.type }</Tag> : undefined }/>
    );
  };

  return (
    <div>
      <div className="text-bpgray-200">Un'origine dati Built-In permette di
        inserire una serie predefinita di variabili relative all'etichetta che
        stai usando.
      </div>
      <div className="text-xl my-3">Seleziona la Built-In</div>
      <div className="text-bpgray-200">Sono disponibili diverse variabili
        Built-In
      </div>
      <BuiltinSelect items={ builtinValues } itemRenderer={ itemRenderer }
                     onItemSelect={ (item) => {
                       setSelectedBuiltin(item);
                       props.onDataOriginChange(new BuiltinDataRef(item.codeName));
                     } }>
        <Button className="my-2"
                rightIcon="caret-down">{ selectedBuiltin?.readableName || 'Selezionare un campo Built-In' }</Button>
      </BuiltinSelect>
    </div>
  );
});